exports.listAllConfigurations = function (state) {
  return state.dal.configuration.listAll(state)
}
